const openers = new Set();

const dimmer = document.querySelector(".facets-dimmer");

const openDimmer = (opener) => {
  openers.add(opener);
  dimmer.classList.add("dimmer--active");
};

const closeDimmer = (opener) => {
  openers.delete(opener);

  if (!openers.size) {
    dimmer.classList.remove("dimmer--active");
  }
};

class FilterDrawer extends HTMLElement {
  constructor() {
    super();

    this.summary = this.querySelector("summary");
    this.details = this.querySelector("details");
    this.summary.addEventListener("click", (e) => {
      e.preventDefault();
      this._toggle();
    });

    this.swipeClose = this.querySelector("[data-swipe-close]");

    this.addEventListener("click", (e) => {
      if (!e.target.closest("[data-drawer-close]")) return;

      this._close();
    });

    // Close on click for non-touch devices
    this.swipeClose.addEventListener("click", () => {
      if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
        this._close();
      }
    });

    this.swipeClose.addEventListener("touchstart", (e) => {
      this.touchstart = e.targetTouches[0].clientY;
      this.touchend = null;
    });

    this.addEventListener("touchmove", (e) => {
      if (!this.touchstart) return;

      this.touchend = e.targetTouches[0].clientY;
      this._setSwipeOffset(Math.max(0, this.touchend - this.touchstart));
    });

    this.addEventListener("touchend", () => {
      if (this.touchend && this.touchend - this.touchstart > 50) {
        this._close();
      } else {
        this._setSwipeOffset(0);
      }
    });

    this.onWindowClick = (e) => {
      if (!document.body.contains(e.target)) return;

      if (!this.contains(e.target) || e.target === dimmer) {
        this._close();
      }
    };

    window.addEventListener("click", this.onWindowClick);

    this.onWindowResize = () => this._toggleOverflow();
    window.addEventListener("resize", this.onWindowResize);

    this.closeEsc = (e) => {
      if (e.key === "Escape" && this.classList.contains("open")) {
        this._close();
      }
    };

    document.addEventListener("keydown", this.closeEsc);
  }

  disconnectedCallback() {
    window.removeEventListener("click", this.onWindowClick);
    window.removeEventListener("resize", this.onWindowResize);
    document.removeEventListener("keydown", this.closeEsc);
  }

  _toggle() {
    this.details.open ? this._close() : this._open();
  }

  _open() {
    this.details.open = true;
    window.requestAnimationFrame(() => {
      this.classList.add("open");
      document.body.classList.add("filter-drawer--open");
      openDimmer(this);
      this._toggleOverflow();
    });
    window.trapFocus(this.details, this.querySelector("[data-drawer-close]"));
  }

  _close() {
    this.classList.remove("open");
    closeDimmer(this);

    const onEnd = () => {
      this.removeEventListener("transitionend", onEnd);

      if (this.classList.contains("open")) return;
      this.details.open = false;
      window.removeTrapFocus(this.summary);
      this._toggleOverflow();
      document.body.classList.remove("filter-drawer--open");
      this.touchstart = null;
      this.touchend = null;
      this._setSwipeOffset(0);
    };
    this.addEventListener("transitionend", onEnd);
  }

  _toggleOverflow() {
    this.classList.contains("open")
      ? window.lockScroll(this)
      : window.unlockScroll(this);
  }

  _setSwipeOffset(px) {
    this.style.setProperty("--swipe-offset", `${isFinite(px) ? px : 0}px`);
  }
}

if (!customElements.get("filter-drawer")) {
  customElements.define("filter-drawer", FilterDrawer);
}
